<template>
  <div>
    <b-container fluid>
      <h1>設計済属性</h1>
      <b-row>
        <button
          class="btn btn-outline-secondary"
          @click="displayAttribute"
        >表示</button>
        <button
          class="btn btn-outline-secondary"
          @click="downloadsCSV"
        >DL</button>
      </b-row>
      <b-row>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          aria-controls="attribute-design-table"
        ></b-pagination>
      </b-row>
      <b-table
        id="attribute-design-table"
        :fields="fields"
        :items="items"
        :current-page="currentPage"
        :per-page="perPage"
        responsive
        small
        bordered
      >
        <template v-slot:cell(no)="data">
          <div>
            {{ data.index + 1 }}
          </div>
        </template>
      </b-table>
    </b-container>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
import { mapState } from 'vuex'
export default {
  name: 'AttributeList',
  data () {
    return {
      displayAttributeTable: false,
      currentPage: 1,
      perPage: 100,
      fields: [
        {
          key: 'attribute_no',
          label: '属性No.',
          sortable: true,
          sortDirection: 'ASC'
        },
        {
          key: 'function_class',
          label: 'システム機能分類.',
          sortable: true
        },
        {
          key: 'property_name',
          label: 'プロパティ名称',
          sortable: true
        },
        {
          key: 'communication_trigger',
          label: '通信トリガ',
          sortable: true
        },
        {
          key: 'frame_type',
          label: 'フレーム種別',
          sortable: true
        },
        {
          key: 'design_sender',
          label: '設計用送信元',
          sortable: true
        },
        {
          key: 'design_destination',
          label: '設計用送信先',
          sortable: true
        },
        {
          key: 'integration_sender',
          label: '統合送信元',
          sortable: true
        },
        {
          key: 'integration_destination',
          label: '統合送信先',
          sortable: true
        },
        {
          key: 'actual_frequency',
          label: '実通信頻度',
          sortable: true
        },
        {
          key: 'attribute_size',
          label: '属性サイズ',
          sortable: true
        }
      ],
      items: []
    }
  },
  computed: {
    totalRows () {
      return this.items.length
    },
    ...mapState(['version'])
  },
  methods: {
    async downloadsCSV () {
      const target = this.items
      let csv = '\ufeff' + this.fields.map(function (elm) { return elm.label }).join(',') + '\n'
      target.forEach(function (elm) {
        this.fields.forEach(function (head, index) {
          if (elm[head.key] === null) {
            csv += ''
          } else {
            csv += elm[head.key]
          }
          if (this.fields.length - 1 === index) {
            csv += '\n'
          } else {
            csv += ','
          }
        }.bind(this))
      }.bind(this))
      let blob = new Blob([csv], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'AttributeList.csv'
      link.click()
      this.all_loading = false
    },
    async displayAttribute () {
      try {
        this.getProperties()
      } catch (e) {
        this.$log.debug(e)
        this.makeToast('失敗', 'エラーが発生しました', 'danger')
      }
    },
    async getProperties () {
      let nextToken = null
      do {
        const result = await API.graphql(graphqlOperation(`
          query getLatestAttribute{
            getLatestDesign(version: "${this.version}"){
              job_id
              version
              status
              attribute_design {
                items {
                  attribute_no
                  function_class
                  property_name
                  communication_trigger
                  frame_type
                  design_sender
                  design_destination
                  integration_sender
                  integration_destination
                  actual_frequency
                  attribute_size
                }
              }
            }
          }
        `))
        this.$log.debug(result)
        if (result.data.getLatestDesign.attribute_design.items.length === 0) {
          this.makeToast('失敗', '表示する属性設計がありません', 'danger')
        } else {
          result.data.getLatestDesign.attribute_design.items.forEach(function (elm) {
            for (const key in elm) {
              if (elm[key] === true) {
                elm[key] = 'はい'
              }
              if (elm[key] === false) {
                elm[key] = 'いいえ'
              }
              if (key === 'actual_frequency') {
                if (elm[key] === 1) {
                  elm[key] = '最短'
                } else if (elm[key] === 60) {
                  elm[key] = '1分'
                } else if (elm[key] === 3600) {
                  elm[key] = '1時間'
                } else if (elm[key] === 86400) {
                  elm[key] = '1日'
                } else if (elm[key] === 2592000) {
                  elm[key] = '1ヶ月'
                } else if (elm[key] === 31536000) {
                  elm[key] = '1年'
                } else {
                  elm[key] = 'その他'
                }
              }
            }
          })
          this.items = [...result.data.getLatestDesign.attribute_design.items]
        }
        nextToken = result.data.getLatestDesign.property_design.nextToken
      } while (nextToken !== null)
    }
  }
}
</script>
